import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e7d4202"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "findlogin-form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Enter your email address", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We'll send you a magic link to log in.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Please check your email", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We have sent you an email link to log in to the app", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_TransparentButton = _resolveComponent("TransparentButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_GoogleAuthButton = _resolveComponent("GoogleAuthButton")!
  const _component_AppVersion = _resolveComponent("AppVersion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.found)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", {
              onKeyup: _cache[1] || (_cache[1] = _withKeys(() => _ctx.$refs.btnSend.onClick(), ["enter"]))
            }, [
              _createVNode(_component_Input, {
                ref: "email",
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                type: "email",
                title: "Email",
                placeholder: "Email",
                regex: /.+@.+\..+/,
                required: true,
                "err-msg": 'Valid email is required'
              }, null, 8, ["modelValue"])
            ], 32),
            _createVNode(_component_TransparentButton, {
              ref: "btnSend",
              text: "Send",
              class: "btn-send",
              click: _ctx.onSend
            }, null, 8, ["click"]),
            _createElementVNode("p", null, [
              _createTextVNode(" Or login with "),
              _createVNode(_component_RouterLink, {
                class: "login-with-email",
                to: { name: 'check-domain' },
                replace: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("email and password ")
                ], undefined, true),
                _: 1
              })
            ]),
            _createVNode(_component_GoogleAuthButton, { onSignin: _ctx.onGoogleSignin }, null, 8, ["onSignin"])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_5,
            _hoisted_6,
            _createVNode(_component_TransparentButton, {
              text: "OPEN YOUR EMAIL",
              class: "btn-white",
              click: _ctx.onClickOpenEmail
            }, null, 8, ["click"]),
            _createVNode(_component_TransparentButton, {
              text: "RESEND EMAIL",
              class: "btn-resend",
              click: _ctx.onClickResendEmail
            }, null, 8, ["click"]),
            _createElementVNode("p", null, [
              _createTextVNode(" Or login with "),
              _createVNode(_component_RouterLink, {
                class: "login-with-email",
                to: { name: 'check-domain' },
                replace: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("email and password")
                ], undefined, true),
                _: 1
              })
            ])
          ], 64)),
      _createVNode(_component_AppVersion)
    ])
  ]))
}